import { render, staticRenderFns } from "./FirstDiagram1.vue?vue&type=template&id=624407ef&scoped=true&"
import script from "./FirstDiagram1.vue?vue&type=script&lang=js&"
export * from "./FirstDiagram1.vue?vue&type=script&lang=js&"
import style0 from "./FirstDiagram1.vue?vue&type=style&index=0&id=624407ef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624407ef",
  null
  
)

export default component.exports